import React from 'react';
import SEO from '../../components/seo';
import { HeroBtnGroup } from '../../components/sections/hero';
import { SubTitle, Title } from '../../components/styles';
import { Button, Col, Row } from 'antd';
import Footer from '../../components/layout/footer';
import Layout from '../../components/layout';

const JoinSEM02b: React.FC<any> = () => {
  return (
    <Layout footerNoNav footerNoAds>
      <SEO
        title="Welcome to AAA | Here's how to make the most of your AAA Membership."
        description="AAA is trusted by 2.1 Million Carolinians."
        canonicalUrl="/joinsem"
      />

      <Row align="middle" gutter={[0, 16]} style={{ minHeight: 660 }}>
        <Col xs={{ span: 22, offset: 1 }} md={{ span: 10, offset: 2 }}>
          <img
            src="/img/members/membership_card@2x.jpg"
            style={{ width: '80%' }}
          />
        </Col>

        <Col xs={{ span: 22, offset: 1 }} md={{ span: 10, offset: 0 }}>
          <Title style={{ maxWidth: '100%' }}>Expect Something More</Title>

          <p style={{ margin: '16px 0' }}>
            Life moves at a fast pace. It can take a turn for the worse when
            you’re on the road. A tire blows out or you accidently lock your
            keys in the car. Expect something more as a valued member of AAA.
            Membership gets you roadside assistance year round, plus receive
            ongoing savings at thousands of retailers, car insurance and
            vacation travel.
          </p>

          <SubTitle style={{ marginBottom: 64 }}>
            Move forward with AAA.
          </SubTitle>

          <HeroBtnGroup>
            <Button
              size="large"
              type="primary"
              style={{ marginRight: 16 }}
              href="https://join.carolinas.aaa.com/"
            >
              Become a Member Today
            </Button>
            <Button
              size="large"
              type="default"
              href="https://carolinas.aaa.com/"
              className="withSubText ctaAlreadyMember"
            >
              Already A Member?
            </Button>
          </HeroBtnGroup>
        </Col>
      </Row>
    </Layout>
  );
};

export default JoinSEM02b;
